import { TypographyCaption, TypographyH2 } from '@heidi/design-system/typography';
import { cn } from '@heidi/utils';

import { planPriceDisplayMessages } from './plan-price-display-messages';
import { renderPlanPriceDisplayCopy } from './render-plan-price-display-copy';
import { resolvePlanPriceDisplayTaxCaption } from './resolve-plan-price-display-tax-caption';
import type { PlanPriceDisplayProps } from './types';

/** Dumb price + caption block for plan billing surfaces. */
export function PlanPriceDisplay({
  price,
  copy,
  locale = 'en',
  className,
}: PlanPriceDisplayProps) {
  const perUserMonth =
    copy === false
      ? false
      : (copy?.perUserMonth ?? planPriceDisplayMessages.perUserMonth);
  const excludeGst =
    copy === false
      ? false
      : (copy?.excludeGst ?? resolvePlanPriceDisplayTaxCaption(locale));

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <TypographyH2 className="text-text-secondary">{price}</TypographyH2>
      {copy !== false ? (
        <div className="flex flex-col">
          {perUserMonth !== false && (
            <TypographyCaption className="text-text-secondary">
              {renderPlanPriceDisplayCopy(perUserMonth)}
            </TypographyCaption>
          )}
          {excludeGst !== false && (
            <TypographyCaption className="text-text-secondary">
              {renderPlanPriceDisplayCopy(excludeGst)}
            </TypographyCaption>
          )}
        </div>
      ) : null}
    </div>
  );
}
